import { useState, useEffect } from 'react';

// Assets
import TemperatureSvg from '../assets/svg/temperature.svg';
import UpperSvg from '../assets/svg/upper.svg';
import LowerSvg from '../assets/svg/lower.svg';
import HeatingSvg from '../assets/svg/heating.svg';
import CoolingSvg from '../assets/svg/cooling.svg';

// API
import { recentData } from '../api/data';

const RecentData = () => {
  const [data, setData] = useState(null);

  const fetchRecentData = async () => {
    const result = await recentData();

    if (result.status === 'success') {
      setData(result.data);
    }
  };

  useEffect(() => {
    fetchRecentData(); // Initial fetch
    const interval = setInterval(fetchRecentData, 300000); // Polling every 5 minutes
    return () => clearInterval(interval); // Cleanup on unmount
  }, []);

  return (
    <div className="recent-data">
      <div className="item">
        <div className="flex-data">
          <div>Temperature Quality</div>
          <img src={TemperatureSvg} alt="Temperature" />
        </div>
        <div className="range">
          <div
            className={`range-value ${
              data
                ? data.pitcherTemp >= 26.5 && data.pitcherTemp <= 28.5
                  ? data.pitcherTemp >= 27 && data.pitcherTemp <= 27.5
                    ? "good"
                    : "moderate"
                  : "danger"
                : ""
            }`}
          >
            {data
              ? data.pitcherTemp >= 26.5 && data.pitcherTemp <= 28.5
                ? data.pitcherTemp >= 27 && data.pitcherTemp <= 27.5
                  ? "Good"
                  : "Moderate"
                : "Danger"
              : "Loading..."}
          </div>
        </div>
        <div className="optimal">
          Previous:{" "}
          <span
            className={`${
              data
                ? data.previouspitcherTemp >= 26.5 && data.previouspitcherTemp <= 28.5
                  ? data.previouspitcherTemp >= 27 && data.previouspitcherTemp <= 27.5
                    ? "good"
                    : "moderate"
                  : "danger"
                : ""
            }`}
          >
            {data
              ? data.previouspitcherTemp >= 26.5 &&
                data.previouspitcherTemp <= 28.5
                ? data.previouspitcherTemp >= 27 &&
                  data.previouspitcherTemp <= 27.5
                  ? "Good"
                  : "Moderate"
                : "Danger"
              : "Loading..."}{" "}
          </span>
        </div>
      </div>

      <div className="item">
        <div className="flex-data">
          <div>Main Tank Temperature</div>
          <img src={TemperatureSvg} alt="Temperature" />
        </div>
        <div className="range">
          <div className="range-value">{data ? data.pitcherTemp : "Loading..."}</div>
          <div className="span">°C</div>
        </div>
        <div className="optimal">Previous: {data ? data.previouspitcherTemp : "Loading..."} °C</div>
      </div>

      <div className="item">
        <div className="flex-data">
          <div>Reservoir Temperature</div>
          <img src={UpperSvg} alt="Temperature" />
        </div>
        <div className="range">
          <div className="range-value">{data ? data.reservoirTemp : "Loading..."}</div>
          <div className="span">°C</div>
        </div>
        <div className="optimal">Previous: {data ? data.previousreservoirTemp : "Loading..."} °C</div>
      </div>

      <div className="item">
        <div className="flex-data">
          <div>Pitcher Temperature</div>
          <img src={LowerSvg} alt="Temperature" />
        </div>
        <div className="range">
          <div className="range-value">{data ? data.pitcherTemp : "Loading..."}</div>
          <div className="span">°C</div>
        </div>
        <div className="optimal">Previous: {data ? data.previouspitcherTemp : "Loading..."} °C</div>
      </div>

      <div className="item">
        <div className="flex-data">
          <div>Heating</div>
          <img src={HeatingSvg} alt="Temperature" />
        </div>
        <div className="range">
          <div className="range-value">
            {data ? (data.heating === "1" ? "On" : "Off") : "Loading..."}
          </div>
        </div>
        <div className="optimal">
          Previous: {data ? (data.previousheating === "1" ? "On" : "Off") : "Loading..."}
        </div>
      </div>

      <div className="item">
        <div className="flex-data">
          <div>Cooling</div>
          <img src={CoolingSvg} alt="Temperature" />
        </div>
        <div className="range">
          <div className="range-value">
            {data ? (data.cooling === "1" ? "On" : "Off") : "Loading..."}
          </div>
        </div>
        <div className="optimal">
          Previous: {data ? (data.previouscooling === "1" ? "On" : "Off") : "Loading..."}
        </div>
      </div>
    </div>
  );
};

export default RecentData;
